import type React from 'react';

import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';

import { useGetStaticAssetUrl } from '@change-corgi/core-react/assets';
import { Translate, useI18n } from '@change-corgi/core-react/i18n';

const APP_STORE_URL =
	'https://apps.apple.com/app/apple-store/id1144132710?pt=2246975&ct=20250409_display_bannner_btn&mt=8';

export const Content: React.FC<{ onClickDownload: () => void }> = ({ onClickDownload }) => {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const { translate } = useI18n();

	return (
		<div className="flex flex-col gap-4">
			<Text variant="heading" size="xx-small" fontWeight="bold">
				<Translate value="corgi.app_download.bottom_banner_v2.mobile.headline" />
			</Text>
			<Text variant="body" size="small">
				<Translate value="corgi.app_download.bottom_banner_v2.mobile.description" />
			</Text>
			<Link href={APP_STORE_URL} target="_blank" onClick={onClickDownload}>
				<img
					src={getStaticAssetUrl('/images/apple-download-on-the-app-store-badge-EN-black-092917.svg')}
					alt={translate('corgi.app_download.bottom_banner_v2.download_on_app_store.image_alt_text')}
					className="w-[180px] min-w-[180px]"
				/>
			</Link>
		</div>
	);
};
